<template>
  <PageWrapper
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_MY_INACTIVE_PUBLICATIONS"
    title="Inactive Publications"
    :breadcrumbs="breadcrumbs"
    page-name="Inactive Publications"
    align="left"
    width="full"
    action-button-text="Create New Publication"
    @click:action="navigateToCreatePublication"
  >
    <SmartFeed
      :pinia-store="useInactivePublicationFeedStore"
      default-smart-feed-layout="grid"
      default-entity-layout="cardSmall"
      load-more-behavior="auto"
    />
  </PageWrapper>
</template>

<script>
import { mapState } from "pinia";
import PageWrapper from "@/components/PageWrapper.vue";
import SmartFeed from "SmartFeed/components/SmartFeed.vue";
import { PAGE_MY_INACTIVE_PUBLICATIONS, SECTION_PUBLICATIONS } from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useInactivePublicationFeedStore } from "SmartFeed/stores/feed/inactive-publication-feed-store";

export default {
  name: "MyInactivePublications",
  components: {
    SmartFeed,
    PageWrapper,
  },
  provide: {
    hideBadge: true,
  },
  data() {
    return {
      SECTION_PUBLICATIONS,
      PAGE_MY_INACTIVE_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
      ];
    },
  },
  methods: {
    useInactivePublicationFeedStore,
    navigateToCreatePublication() {
      window.location = `/publication/org/${this.orgId}/create`;
    },
  },
};
</script>
